import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import ICU from 'i18next-icu';
import { getAbsoluteRoot } from "helpers/urlRoot";

/**
 * Documentation: 
 * https://i18next.github.io/i18next/pages/doc_init.html 
 * https://www.i18next.com/
 * https://blog.logrocket.com/react-localization-with-i18next/
 * fallbackNS Si no encuentra una descripcion en un namespace lo busca en el namespace por defecto ,
 */

//const getLanguage = () => navigator.userLanguage || (navigator.languages && navigator.languages.length && navigator.languages[0]) || navigator.language || navigator.browserLanguage || navigator.systemLanguage || 'en';
const root_ = getAbsoluteRoot();
i18next
  .use(ICU)
  .use(initReactI18next)
  .use(HttpApi) // Registering the back-end plugin
  .init({
    // resources,
    lng: "eng",//getLanguage(),
    fallbackLng: "eng",
    debug: false,
    ns: "labels",
    nsseparator: ':::',

    //ns: ["translations", "common"],
    //defaultNS: "translations",
    fallbackNS: "labels",
    // initImmediate: false,

    returnEmptyString: false,
    interpolation: {
      escapeValue: false,
      formatSeparator: "."
    },
    react: {
      wait: true,
      useSuspense: true //If change to false , we can remove Suspense in Index.js
    },
    backend: {
      //loadPath: "/locales/{{ns}}/{{lng}}.json"  resturn  /locales/translations/es.json
      loadPath: `${root_}locales/{{lng}}/labels.json`, //From Public folder
      allowMultiLoading: true

    }

  })
export default i18next;